const INITIAL_STATE = {
    veiculos: {data : []},
    veiculo: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'VEICULOS_FETCH':
            return { ...state, veiculos: action.payload }
        case 'VEICULO_FETCH':
            return { ...state, veiculo: action.payload }
        default:
            return state
    }
}